const Customers = {
  ADDING_CUSTOMER: 'customer/add',
  CUSTOMER_ARCHIVE_ACTION: 'customer/archive_action',
  CUSTOMER_UPDATE_SUCCESS: 'customer/update_success',
}

export default Customers;